import { WidgetHandler } from '../../WidgetHandler';
import { callEventFunction } from './callEventFunction';
export function renderForm(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
props, options) {
    if (options === null || options === void 0 ? void 0 : options.changed) {
        props.internalData.changed = true;
        callEventFunction(props, 'onChange', 'value, handler', props.getData(), new WidgetHandler(props));
    }
    const widgetData = props.render();
    if ((options === null || options === void 0 ? void 0 : options.changed) && props.rootParams.onChange) {
        props.rootParams.onChange(widgetData);
    }
    if (((options === null || options === void 0 ? void 0 : options.autoSaveDebounce) || (options === null || options === void 0 ? void 0 : options.autoSaveImmediately)) && props.rootParams.onAutoSave && widgetData.valid) {
        props.rootParams.onAutoSave(widgetData, !!(options === null || options === void 0 ? void 0 : options.autoSaveImmediately));
    }
}
